import React from 'react'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(100)};
  width: 100%;
  aspect-ratio: 3.3 / 1;
  overflow: hidden;
`

function TuroModalImage() {
  return (
    <ImageContainer>
      <Image
        image={{ id: 'yatwrvvmzmintrr84gpa' }}
        fit="center"
        objectFit="cover"
        alt="Turo Modal Image"
      />
    </ImageContainer>
  )
}

export default TuroModalImage
